/* cc-hero.js — Cologne Curators hero carousel (Skins-style).
   translateX track, numbered dots, prev/next/pause, autoplay (off for
   reduced-motion), pause on hover/focus, arrow keys. No dependencies. */
(function () {
  function init(root) {
    if (root.__ccHero) return; root.__ccHero = true;
    var track = root.querySelector('[data-hero-track]');
    var slides = [].slice.call(root.querySelectorAll('[data-hero-slide]'));
    var dots = [].slice.call(root.querySelectorAll('[data-hero-dot]'));
    var toggle = root.querySelector('[data-hero-toggle]');
    var n = slides.length;
    if (n < 2 || !track) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var speed = (parseInt(root.getAttribute('data-autoplay'), 10) || 0) * 1000;
    var i = 0, timer = null, playing = false;

    function render() {
      track.style.transform = 'translateX(' + (-i * 100) + '%)';
      slides.forEach(function (s, k) {
        var on = k === i;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        var cta = s.querySelector('.cc-hero__cta');
        if (cta) cta.setAttribute('tabindex', on ? '0' : '-1');
      });
      dots.forEach(function (d, k) {
        var on = k === i;
        d.classList.toggle('is-active', on);
        if (on) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
      });
    }
    function go(to) { i = (to + n) % n; render(); }
    function next() { go(i + 1); }
    function prev() { go(i - 1); }

    function play() {
      if (reduce || !speed) return;
      stop(); playing = true; timer = setInterval(next, speed);
      if (toggle) { toggle.setAttribute('aria-pressed', 'false'); toggle.setAttribute('aria-label', 'Pause slideshow'); root.classList.remove('is-paused'); }
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function pauseByUser() {
      stop(); playing = false;
      if (toggle) { toggle.setAttribute('aria-pressed', 'true'); toggle.setAttribute('aria-label', 'Play slideshow'); root.classList.add('is-paused'); }
    }

    dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-hero-dot'), 10)); if (playing) play(); }); });
    var pv = root.querySelector('[data-hero-prev]'); if (pv) pv.addEventListener('click', function () { prev(); if (playing) play(); });
    var nx = root.querySelector('[data-hero-next]'); if (nx) nx.addEventListener('click', function () { next(); if (playing) play(); });
    if (toggle) toggle.addEventListener('click', function () { if (playing) pauseByUser(); else play(); });

    // pause on hover / focus, resume after
    root.addEventListener('mouseenter', function () { if (playing) stop(); });
    root.addEventListener('mouseleave', function () { if (playing) play(); });
    root.addEventListener('focusin', function () { if (playing) stop(); });
    root.addEventListener('focusout', function () { if (playing && !root.contains(document.activeElement)) play(); });

    // arrow keys when focus is within the hero
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { prev(); if (playing) play(); }
      else if (e.key === 'ArrowRight') { next(); if (playing) play(); }
    });

    // pause when tab hidden
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else if (playing) play(); });

    // touch swipe to change slides (Arun 2026-11-03). Passive listeners that never
    // preventDefault, so vertical page scroll is untouched; we only act on a release
    // once the gesture is clearly horizontal (dx dominates dy) and past a 40px threshold.
    var tsx = 0, tsy = 0, tActive = false, tDecided = false, tHoriz = false;
    root.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      tsx = e.touches[0].clientX; tsy = e.touches[0].clientY;
      tActive = true; tDecided = false; tHoriz = false;
    }, { passive: true });
    root.addEventListener('touchmove', function (e) {
      if (!tActive || tDecided) return;
      var dx = e.touches[0].clientX - tsx, dy = e.touches[0].clientY - tsy;
      if (Math.abs(dx) < 10 && Math.abs(dy) < 10) return;
      tDecided = true; tHoriz = Math.abs(dx) > Math.abs(dy) * 1.2;
    }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (!tActive) return; tActive = false;
      if (!tHoriz) return;
      var end = e.changedTouches && e.changedTouches[0] ? e.changedTouches[0].clientX : tsx;
      var dx = end - tsx;
      if (Math.abs(dx) < 40) return;
      if (dx < 0) next(); else prev();
      if (playing) play();
    }, { passive: true });
    root.addEventListener('touchcancel', function () { tActive = false; }, { passive: true });

    render();
    play();
  }

  function boot() { [].slice.call(document.querySelectorAll('[data-cc-hero][data-autoplay], [data-cc-hero]')).forEach(init); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
})();
